import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {InvoiceLayoutService} from '../../../Services/invoice-layout.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';

@Component({
  selector: 'app-invoice-layout-overview',
  templateUrl: './invoice-layout-overview.component.html',
  styleUrls: ['./invoice-layout-overview.component.scss']
})
export class InvoiceLayoutOverviewComponent implements OnInit {

  public grid: Grid;
  public layoutId: number;
  public layoutName: string;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(
    private router: Router,
    private invoiceLayoutService: InvoiceLayoutService,
    private translateService: TranslateService,
    private broadCastService: BroadcastService
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.invoice_layout.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          width: 300,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.option.type',
          prop: 'isCredit',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('pdf.credit_invoice');
              case false:
                return this.translateService.instant('pdf.invoice');
            }
          }
        },
        <TextColumn>{
          name: 'global.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <NumberColumn>{
          name: 'global.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          maxWidth: 100,
          minWidth: 100,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.invoiceLayoutService.setPosition(position, row.id).subscribe((res) => {
              this.broadCastService.broadcast('refreshGrid', 'getLayoutList');

            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/invoice-layout/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.layoutId = row.id;
                this.layoutName = row.name.bold();
                this.deleteModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        },
      ],
      service: this.invoiceLayoutService,
      rememberURL: this.router.url,
      method: 'getLayoutList',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
    };
  }

  delete() {
    this.invoiceLayoutService.delete(this.layoutId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadCastService.broadcast('refreshGrid', 'getLayoutList');
    });
  }
}
